import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

import initialStore, { type DiscoverStore } from './initialDiscoverStore';

const useDiscoverStore = create<DiscoverStore>()(subscribeWithSelector(() => initialStore));

export default useDiscoverStore;
